import { Typography } from '@mui/material'
import { CustomPagination } from 'components/purchase/CustomPagination'
import { PurchasePlansFilters } from 'pages/purchase-pages/purchase-plans/PurchasePlansFilters'
import { PurchaseLayout } from 'hoc/PurchaseLayout'
import React, { useState } from 'react'
import { PurchasePlansTable } from './PurchasePlansTable'
import { useQueryState } from 'react-router-use-location-state'
import { useProcurementPlansSearchQuery } from 'services/procurementPlans'
import { EmptyTableState } from 'components/purchase/EmptyTableState'
import { useTranslation } from 'react-i18next'

const breadCrumbItems = [
  {
    id: 'home',
    title: 'Ana səhifə',
    path: '/',
  },
  {
    id: 'procurement_plans',
    title: 'Satınalma planları',
  },
]

export const PurchasePlans: React.FC = () => {
  const [page, setPage] = useQueryState('page', 0)
  const rowsPerPage = 10
  const [filters, setFilters] = useState<any>({
    orgName: '',
    year: new Date().getFullYear().toString(),
  })
  const { t } = useTranslation()

  const args = {
    page,
    size: rowsPerPage,
    orgName: filters.orgName,
    year: filters.year,
  } as const

  const { data } = useProcurementPlansSearchQuery(args, {
    refetchOnMountOrArgChange: true,
  })

  return (
    <PurchaseLayout breadCrumbItems={breadCrumbItems}>
      <Typography variant="h5">{t('procurement_plans')}</Typography>
      <PurchasePlansFilters setFilters={setFilters} />
      {data?.items && data?.items.length !== 0 ? (
        <PurchasePlansTable data={data?.items} />
      ) : (
        <EmptyTableState />
      )}
      {data?.info.totalRows !== 0 && (
        <CustomPagination
          total={data?.info.totalRows!}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={setPage}
        />
      )}
    </PurchaseLayout>
  )
}
